import { usePlaylistCurrentlySelected } from '@statsbomb/video-client-js';
import { useEffect } from 'react';
import { trackContentPlaybackEvent } from '../analytics';

export const useTrackVideoStart = () => {
  const [videoPlaylistCurrentlySelected] = usePlaylistCurrentlySelected();

  useEffect(() => {
    if (videoPlaylistCurrentlySelected?.id) {
      trackContentPlaybackEvent({
        contentType: 'Video',
        playbackActionType: 'Start',
      });
    }
  }, [videoPlaylistCurrentlySelected?.id]);
};
